import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { initParams } from '../../configs';

const { permissions } = initParams;

const TotalNotAvailable = ({ variant }) => (
  <div className={cx('img-cover total-not-available', `total-not-available--${variant}`)}>
    <span className="m-x-auto m-y-auto text-xxxs">
      {permissions.isFlexUser
        ? 'Not included in your plan'
        : !permissions.prospect && (
            <>
              <a href="/pricing">Upgrade</a>
              &nbsp;to see this data
            </>
          )}
    </span>
  </div>
);

TotalNotAvailable.propTypes = {
  variant: PropTypes.oneOf(['blue', 'green', 'gray']).isRequired,
};

export default TotalNotAvailable;
